import { ajax as rxAjax } from 'rxjs/ajax';
import { catchError } from 'rxjs/operators';
import { handleUnauthorized } from '../../hooks/auth/auth.hook';

// Même API que rxjs/ajax, mais toute réponse 401 déconnecte et renvoie au login.
const withSessionCheck = (request$) => request$.pipe(catchError(handleUnauthorized));

const ajax = (config) => withSessionCheck(rxAjax(config));
ajax.get = (...args) => withSessionCheck(rxAjax.get(...args));
ajax.getJSON = (...args) => withSessionCheck(rxAjax.getJSON(...args));
ajax.post = (...args) => withSessionCheck(rxAjax.post(...args));
ajax.put = (...args) => withSessionCheck(rxAjax.put(...args));
ajax.patch = (...args) => withSessionCheck(rxAjax.patch(...args));
ajax.delete = (...args) => withSessionCheck(rxAjax.delete(...args));

export {
  ajax,
};
